import React from 'react'
import ReactDOM from 'react-dom/client'
import './styles/styles.scss'
import App from './config/App'

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
